module.exports = __webpack_public_path__ + "img/ypm_QrCode.cd99f114.jpg";